import { gql } from '@apollo/client'

export const MUTATION_SEND_OBSERVATIONS_REPORT = gql`
  mutation sendObservationsReport($input: ObservationReportInput!) {
    sendObservationsReport(input: $input)
  }
`

export const MUTATION_SEND_FORMS_REPORT = gql`
  mutation sendFormsReport($input: FormReportInput!) {
    sendFormsReport(input: $input)
  }
`

export const MUTATION_SEND_PLANNING_REPORT = gql`
  mutation sendPlanningReport($input: PlanningReportInput!) {
    sendPlanningReport(input: $input)
  }
`
